import React, { useEffect, useState } from 'react';
import './scss/full-screen-loader.scss';
import { Modal } from 'react-bootstrap';
import FormDialogProp from './properties/form-dialog';

function FormDialog({
  show, onHide, formElement,
}:FormDialogProp): React.ReactElement {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(show);
  }, [show]);

  return (
    <Modal
      show={showModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onHide}
      scrollable
    >
      <Modal.Body>
        {formElement}
      </Modal.Body>
    </Modal>
  );
}

export default FormDialog;
